import { PropsWithChildren } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { locationToPath } from "../../../auth/utils/returnTo";

interface GuardBaseProps {
  redirectPath: string;
  haveAccess: boolean;
}

type GuardProps = PropsWithChildren<GuardBaseProps>;

export const Guard = ({ children, redirectPath, haveAccess }: GuardProps) => {
  const location = useLocation();

  if (!haveAccess) {
    // Carry the attempted URL so the auth flow can return to it after sign-in
    return <Navigate to={redirectPath} replace state={{ from: locationToPath(location) }} />;
  }

  // Children cannot be returned directly
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return children ? <>{children}</> : <Outlet />;
};
